export const DINING_ERROR_CODES = {
  UNAVAILABLE_SELECTION: 'dining_unavailable_selection',
  MISSING_CONTEXT: 'dining_missing_context',
  PASSENGERS_REQUIRED: 'dining_passengers_required',
  UNKNOWN: 'unknown_error',
} as const;
